var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background py-3"},[_vm._l((_vm.results),function(search){return [_c('search-card',{staticClass:"mb-3",attrs:{"disabled":"","search":search}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }